/**
 * Pure helpers for the My Feed "Needs your attention" card (GROWTH-7133).
 * Behaviour inventory: docs/testing/inventories/NeedsAttention.md
 */

/** The `top_missing_field` values GET /api-v2/dashboard-bootstrap can send (ProfileCompletion::FIELDS, GROWTH-7134). */
export const PROFILE_COMPLETION_FIELDS = ["photo", "bio", "practice_areas", "languages", "licenses", "phone", "address", "website"];

/** What a field the dashboard has no label for falls back to, so a new backend field never shows its raw key. */
export const GENERIC_FIELD = "generic";

/**
 * The rows the card shows, in order: unread messages, then profile completion. A row with nothing to say is left out,
 * so an empty list means the whole card is hidden.
 *
 * - messages: `profile.new_messages`, the number the sidebar Inbox badge shows. The store holds it as a string and as ""
 *   before the profile has loaded; anything that is not a whole number above zero hides the row.
 * - profile: `profile.profile_completion` ({score, top_missing_field}). Hidden at 100 %, when nothing is missing, and
 *   when the member has no profile listing (null) or the server sent none.
 *
 * @param {Object} input
 * @param {string|number} [input.newMessages] profile.new_messages
 * @param {?{score: number, top_missing_field: ?string}} [input.profileCompletion] profile.profile_completion
 * @returns {Array<{key: "messages", count: number}|{key: "profile", score: number, field: string}>}
 */
export const buildAttentionRows = ({ newMessages, profileCompletion } = {}) => {
  const rows = [];

  const count = Number(newMessages);
  if (Number.isInteger(count) && count > 0) {
    rows.push({ key: "messages", count });
  }

  const score = profileCompletion?.score;
  const field = profileCompletion?.top_missing_field;
  if (typeof score === "number" && score < 100 && typeof field === "string" && field !== "") {
    rows.push({
      key: "profile",
      score: Math.max(0, Math.round(score)),
      field: PROFILE_COMPLETION_FIELDS.includes(field) ? field : GENERIC_FIELD
    });
  }

  return rows;
};
